import Typography from '@/features/ui/typography'
import React, { FC } from 'react'

const Loader: FC = () => {
    return (
        <Typography.Heading style={{ textAlign: 'center', marginBottom: 16 }}>
            ...
        </Typography.Heading>
    )
}

export default Loader
